import { render, staticRenderFns } from "./manipulated_order_items_table.vue?vue&type=template&id=0a2406e7&lang=pug&"
import script from "./manipulated_order_items_table.vue?vue&type=script&lang=js&"
export * from "./manipulated_order_items_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports